import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Button } from 'react-bootstrap';
import { BASE_SITE, WITHDRAW_REQUEST_POST } from '../../../../apis'; 
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleChangeDataWithdrawWalletPage } from '../../../../redux/actions/pages/wallet/withdraw';
import { handleChangeDataBottomSheet } from '../../../../redux/actions/partials/footer/bottom_sheet';
import axios from "axios";
import * as qs from "querystring";
import BackIcon from '../../../../styles/images/back-without-bg.png';


const Withdraw = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { token, profile } = useSelector(state => state.user);
    const { amount, sheba } = useSelector(state => state.withdraw);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    


    const handleBtnWithdrawClick = () => {
        if(! isBackdropLoading) {
            if(parseInt(removeNonNumeric(amount)) >= 500000) {
                dispatch(handleSetBackdropLoading(true));

                axios({
                    method: 'post',
                    url: BASE_SITE + WITHDRAW_REQUEST_POST,
                    data: qs.stringify({
                        amount: removeNonNumeric(amount),
                        sheba,
                    }), headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Authorization': token,
                    },
                }).then((response) => {
                    switch (response.data.status) {
                        case 'error':
                            dispatch(handleSetOpenCustomSnackbar(true, {message: response.data.message, severity: 'error', vertical: 'top', horizontal: 'center'}));  
                            break;
                        case 'ok':
                            dispatch(handleChangeDataWithdrawWalletPage('amount', ''));
                            dispatch(handleChangeDataWithdrawWalletPage('sheba', 'IR - '));
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'درخواست شما با موفقیت ثبت شد', severity: 'success', vertical: 'top', horizontal: 'center'}));  
                            handleBackBtn();
                            break;
                        default:
                            dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                    }
                    dispatch(handleSetBackdropLoading(false));
                }, () => {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                    dispatch(handleSetBackdropLoading(false));
                });
            }
            else 
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'حداقل مبلغ پانصد  هزار ریال میباشد!', severity: 'error', vertical: 'top', horizontal: 'center'}));  
        }
    };

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        if(name === 'amount')
            dispatch(handleChangeDataWithdrawWalletPage(name, addCommas(removeNonNumeric(changeNumberPersianAndArabic(value))) ));
        else if(value.startsWith('IR - ')) {
            let numericSegment = value.replace('IR - ', '');
            if(!isNaN(+numericSegment))
                dispatch(handleChangeDataWithdrawWalletPage(name, value));
        }
    };

    const handleBackBtn = () => {
        navigate(-1);
    };


    const closeBottomSheet = () => {
        dispatch(handleChangeDataBottomSheet('isOpen', false));
    };

    return (

        <div id="charge-wallet-page" onClick={closeBottomSheet} >

            <Row className="pt-4 white-bg pb-3">
                <Col xs={1}><img src={BackIcon} alt="back" onClick={handleBackBtn} role="button" /></Col>
                <Col xs={10}><h4 className="text-center">برداشت وجه</h4></Col>
                <Col xs={1}></Col>
            </Row>

            <div className="short-profile text-center mt-5 font-size-18 font-weight-300 py-5">
                موجودی قابل برداشت {profile.user_credit.toLocaleString()} ریال
            </div>

            <Row>
                <Col xs={12} className="mt-5">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >مبلغ به ریال</label>
                        <input type="text" name="amount" value={amount} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" />
                    </div>
                </Col>

                <Col xs={12} className="mt-3">
                    <div className="input-wrapper" >
                        <label className="label-wrapper ml-3" htmlFor="first" >شماره شبای شخصی</label>
                        <input type="text" name="sheba" value={sheba} onChange={handelChangeInputs} className="custom-input w-100 px-3 custom-vertical-padding" style={{direction: "ltr"}} />
                    </div>
                </Col>

                <Col xs={12} className="mt-4">
                    <Button onClick={handleBtnWithdrawClick} className="w-100 py-3 login-form-button">
                        برداشت
                    </Button>
                </Col>

                <ul className="mt-3">
                    <li>حداقل مبلغ برداشت 50 هزار تومان میباشد</li>
                    <li>شماره شبا باید به نام صاحب شماره موبایل حساب کاربری باشد</li>
                    <li>کارمزد برداشت از حساب شما کسر میگردد</li>
                </ul>             
            </Row>


        </div>
    );
}

export default Withdraw;